import React, { useMemo } from 'react';
import { ShopifyContext } from './ShopifyContext';
import { DEFAULT_API_VERSION } from './consts';
export { DEFAULT_API_VERSION } from './consts';
/**
 * The `ShopifyProvider` component wraps your entire app and provides support for hooks.
 * You should place it in your app's entry point component. For example, `<App>`.
 */
export function ShopifyProvider({ shopifyConfig, children, }) {
    const shopifyProviderValue = useMemo(() => {
        var _a;
        return ({
            locale: 'en-us',
            graphqlApiVersion: DEFAULT_API_VERSION,
            ...shopifyConfig,
            storeDomain: (_a = shopifyConfig === null || shopifyConfig === void 0 ? void 0 : shopifyConfig.storeDomain) === null || _a === void 0 ? void 0 : _a.replace(/^https?:\/\//, ''),
        });
    }, [shopifyConfig]);
    return (React.createElement(ShopifyContext.Provider, { value: shopifyProviderValue }, children));
}
